
const dialCodeList =[{
    "label": "Afghanistan",
    "value": "+93",
    "emoji": "🇦🇫",
    "code": "AF"
},
{
    "label": "Aland Islands",
    "value": "+358",
    "emoji": "🇦🇽",
    "code": "AX"
},
{
    "label": "Albania",
    "value": "+355",
    "emoji": "🇦🇱",
    "code": "AL"
},
{
    "label": "Algeria",
    "value": "+213",
    "emoji": "🇩🇿",
    "code": "DZ"
},
{
    "label": "AmericanSamoa",
    "value": "+1684",
    "emoji": "🇦🇸",
    "code": "AS"
},
{
    "label": "Andorra",
    "value": "+376",
    "emoji": "🇦🇩",
    "code": "AD"
},
{
    "label": "Angola",
    "value": "+244",
    "emoji": "🇦🇴",
    "code": "AO"
},
{
    "label": "Anguilla",
    "value": "+1264",
    "emoji": "🇦🇮",
    "code": "AI"
},
{
    "label": "Antarctica",
    "value": "+672",
    "emoji": "🇦🇶",
    "code": "AQ"
},
{
    "label": "Antigua and Barbuda",
    "value": "+1268",
    "emoji": "🇦🇬",
    "code": "AG"
},
{
    "label": "Argentina",
    "value": "+54",
    "emoji": "🇦🇷",
    "code": "AR"
},
{
    "label": "Armenia",
    "value": "+374",
    "emoji": "🇦🇲",
    "code": "AM"
},
{
    "label": "Aruba",
    "value": "+297",
    "emoji": "🇦🇼",
    "code": "AW"
},
{
    "label": "Australia",
    "value": "+61",
    "emoji": "🇦🇺",
    "code": "AU"
},
{
    "label": "Austria",
    "value": "+43",
    "emoji": "🇦🇹",
    "code": "AT"
},
{
    "label": "Azerbaijan",
    "value": "+994",
    "emoji": "🇦🇿",
    "code": "AZ"
},
{
    "label": "Bahamas",
    "value": "+1242",
    "emoji": "🇧🇸",
    "code": "BS"
},
{
    "label": "Bahrain",
    "value": "+973",
    "emoji": "🇧🇭",
    "code": "BH"
},
{
    "label": "Bangladesh",
    "value": "+880",
    "emoji": "🇧🇩",
    "code": "BD"
},
{
    "label": "Barbados",
    "value": "+1246",
    "emoji": "🇧🇧",
    "code": "BB"
},
{
    "label": "Belarus",
    "value": "+375",
    "emoji": "🇧🇾",
    "code": "BY"
},
{
    "label": "Belgium",
    "value": "+32",
    "emoji": "🇧🇪",
    "code": "BE"
},
{
    "label": "Belize",
    "value": "+501",
    "emoji": "🇧🇿",
    "code": "BZ"
},
{
    "label": "Benin",
    "value": "+229",
    "emoji": "🇧🇯",
    "code": "BJ"
},
{
    "label": "Bermuda",
    "value": "+1441",
    "emoji": "🇧🇲",
    "code": "BM"
},
{
    "label": "Bhutan",
    "value": "+975",
    "emoji": "🇧🇹",
    "code": "BT"
},
{
    "label": "Bolivia, Plurinational State of",
    "value": "+591",
    "emoji": "🇧🇴",
    "code": "BO"
},
{
    "label": "Bosnia and Herzegovina",
    "value": "+387",
    "emoji": "🇧🇦",
    "code": "BA"
},
{
    "label": "Botswana",
    "value": "+267",
    "emoji": "🇧🇼",
    "code": "BW"
},
{
    "label": "Brazil",
    "value": "+55",
    "emoji": "🇧🇷",
    "code": "BR"
},
{
    "label": "British Indian Ocean Territory",
    "value": "+246",
    "emoji": "🇮🇴",
    "code": "IO"
},
{
    "label": "Brunei Darussalam",
    "value": "+673",
    "emoji": "🇧🇳",
    "code": "BN"
},
{
    "label": "Bulgaria",
    "value": "+359",
    "emoji": "🇧🇬",
    "code": "BG"
},
{
    "label": "Burkina Faso",
    "value": "+226",
    "emoji": "🇧🇫",
    "code": "BF"
},
{
    "label": "Burundi",
    "value": "+257",
    "emoji": "🇧🇮",
    "code": "BI"
},
{
    "label": "Cambodia",
    "value": "+855",
    "emoji": "🇰🇭",
    "code": "KH"
},
{
    "label": "Cameroon",
    "value": "+237",
    "emoji": "🇨🇲",
    "code": "CM"
},
{
    "label": "Canada",
    "value": "+1",
    "emoji": "🇨🇦",
    "code": "CA"
},
{
    "label": "Cape Verde",
    "value": "+238",
    "emoji": "🇨🇻",
    "code": "CV"
},
{
    "label": "Cayman Islands",
    "value": "+345",
    "emoji": "🇰🇾",
    "code": "KY"
},
{
    "label": "Central African Republic",
    "value": "+236",
    "emoji": "🇨🇫",
    "code": "CF"
},
{
    "label": "Chad",
    "value": "+235",
    "emoji": "🇹🇩",
    "code": "TD"
},
{
    "label": "Chile",
    "value": "+56",
    "emoji": "🇨🇱",
    "code": "CL"
},
{
    "label": "China",
    "value": "+86",
    "emoji": "🇨🇳",
    "code": "CN"
},
{
    "label": "Christmas Island",
    "value": "+61",
    "emoji": "🇨🇽",
    "code": "CX"
},
{
    "label": "Cocos (Keeling) Islands",
    "value": "+61",
    "emoji": "🇨🇨",
    "code": "CC"
},
{
    "label": "Colombia",
    "value": "+57",
    "emoji": "🇨🇴",
    "code": "CO"
},
{
    "label": "Comoros",
    "value": "+269",
    "emoji": "🇰🇲",
    "code": "KM"
},
{
    "label": "Congo",
    "value": "+242",
    "emoji": "🇨🇬",
    "code": "CG"
},
{
    "label": "Congo, The Democratic Republic of the Congo",
    "value": "+243",
    "emoji": "🇨🇩",
    "code": "CD"
},
{
    "label": "Cook Islands",
    "value": "+682",
    "emoji": "🇨🇰",
    "code": "CK"
},
{
    "label": "Costa Rica",
    "value": "+506",
    "emoji": "🇨🇷",
    "code": "CR"
},
{
    "label": "Cote d'Ivoire",
    "value": "+225",
    "emoji": "🇨🇮",
    "code": "CI"
},
{
    "label": "Croatia",
    "value": "+385",
    "emoji": "🇭🇷",
    "code": "HR"
},
{
    "label": "Cuba",
    "value": "+53",
    "emoji": "🇨🇺",
    "code": "CU"
},
{
    "label": "Cyprus",
    "value": "+357",
    "emoji": "🇨🇾",
    "code": "CY"
},
{
    "label": "Czech Republic",
    "value": "+420",
    "emoji": "🇨🇿",
    "code": "CZ"
},
{
    "label": "Denmark",
    "value": "+45",
    "emoji": "🇩🇰",
    "code": "DK"
},
{
    "label": "Djibouti",
    "value": "+253",
    "emoji": "🇩🇯",
    "code": "DJ"
},
{
    "label": "Dominica",
    "value": "+1767",
    "emoji": "🇩🇲",
    "code": "DM"
},
{
    "label": "Dominican Republic",
    "value": "+1849",
    "emoji": "🇩🇴",
    "code": "DO"
},
{
    "label": "Ecuador",
    "value": "+593",
    "emoji": "🇪🇨",
    "code": "EC"
},
{
    "label": "Egypt",
    "value": "+20",
    "emoji": "🇪🇬",
    "code": "EG"
},
{
    "label": "El Salvador",
    "value": "+503",
    "emoji": "🇸🇻",
    "code": "SV"
},
{
    "label": "Equatorial Guinea",
    "value": "+240",
    "emoji": "🇬🇶",
    "code": "GQ"
},
{
    "label": "Eritrea",
    "value": "+291",
    "emoji": "🇪🇷",
    "code": "ER"
},
{
    "label": "Estonia",
    "value": "+372",
    "emoji": "🇪🇪",
    "code": "EE"
},
{
    "label": "Ethiopia",
    "value": "+251",
    "emoji": "🇪🇹",
    "code": "ET"
},
{
    "label": "Falkland Islands (Malvinas)",
    "value": "+500",
    "emoji": "🇫🇰",
    "code": "FK"
},
{
    "label": "Faroe Islands",
    "value": "+298",
    "emoji": "🇫🇴",
    "code": "FO"
},
{
    "label": "Fiji",
    "value": "+679",
    "emoji": "🇫🇯",
    "code": "FJ"
},
{
    "label": "Finland",
    "value": "+358",
    "emoji": "🇫🇮",
    "code": "FI"
},
{
    "label": "France",
    "value": "+33",
    "emoji": "🇫🇷",
    "code": "FR"
},
{
    "label": "French Guiana",
    "value": "+594",
    "emoji": "🇬🇫",
    "code": "GF"
},
{
    "label": "French Polynesia",
    "value": "+689",
    "emoji": "🇵🇫",
    "code": "PF"
},
{
    "label": "Gabon",
    "value": "+241",
    "emoji": "🇬🇦",
    "code": "GA"
},
{
    "label": "Gambia",
    "value": "+220",
    "emoji": "🇬🇲",
    "code": "GM"
},
{
    "label": "Georgia",
    "value": "+995",
    "emoji": "🇬🇪",
    "code": "GE"
},
{
    "label": "Germany",
    "value": "+49",
    "emoji": "🇩🇪",
    "code": "DE"
},
{
    "label": "Ghana",
    "value": "+233",
    "emoji": "🇬🇭",
    "code": "GH"
},
{
    "label": "Gibraltar",
    "value": "+350",
    "emoji": "🇬🇮",
    "code": "GI"
},
{
    "label": "Greece",
    "value": "+30",
    "emoji": "🇬🇷",
    "code": "GR"
},
{
    "label": "Greenland",
    "value": "+299",
    "emoji": "🇬🇱",
    "code": "GL"
},
{
    "label": "Grenada",
    "value": "+1473",
    "emoji": "🇬🇩",
    "code": "GD"
},
{
    "label": "Guadeloupe",
    "value": "+590",
    "emoji": "🇬🇵",
    "code": "GP"
},
{
    "label": "Guam",
    "value": "+1671",
    "emoji": "🇬🇺",
    "code": "GU"
},
{
    "label": "Guatemala",
    "value": "+502",
    "emoji": "🇬🇹",
    "code": "GT"
},
{
    "label": "Guernsey",
    "value": "+44",
    "emoji": "🇬🇬",
    "code": "GG"
},
{
    "label": "Guinea",
    "value": "+224",
    "emoji": "🇬🇳",
    "code": "GN"
},
{
    "label": "Guinea-Bissau",
    "value": "+245",
    "emoji": "🇬🇼",
    "code": "GW"
},
{
    "label": "Guyana",
    "value": "+595",
    "emoji": "🇬🇾",
    "code": "GY"
},
{
    "label": "Haiti",
    "value": "+509",
    "emoji": "🇭🇹",
    "code": "HT"
},
{
    "label": "Holy See (Vatican City State)",
    "value": "+379",
    "emoji": "🇻🇦",
    "code": "VA"
},
{
    "label": "Honduras",
    "value": "+504",
    "emoji": "🇭🇳",
    "code": "HN"
},
{
    "label": "Hong Kong",
    "value": "+852",
    "emoji": "🇭🇰",
    "code": "HK"
},
{
    "label": "Hungary",
    "value": "+36",
    "emoji": "🇭🇺",
    "code": "HU"
},
{
    "label": "Iceland",
    "value": "+354",
    "emoji": "🇮🇸",
    "code": "IS"
},
{
    "label": "India",
    "value": "+91",
    "emoji": "🇮🇳",
    "code": "IN"
},
{
    "label": "Indonesia",
    "value": "+62",
    "emoji": "🇮🇩",
    "code": "ID"
},
{
    "label": "Iran, Islamic Republic of Persian Gulf",
    "value": "+98",
    "emoji": "🇮🇷",
    "code": "IR"
},
{
    "label": "Iraq",
    "value": "+964",
    "emoji": "🇮🇷",
    "code": "IQ"
},
{
    "label": "Ireland",
    "value": "+353",
    "emoji": "🇮🇪",
    "code": "IE"
},
{
    "label": "Isle of Man",
    "value": "+44",
    "emoji": "🇮🇲",
    "code": "IM"
},
{
    "label": "Israel",
    "value": "+972",
    "emoji": "🇮🇱",
    "code": "IL"
},
{
    "label": "Italy",
    "value": "+39",
    "emoji": "🇮🇹",
    "code": "IT"
},
{
    "label": "Jamaica",
    "value": "+1876",
    "emoji": "🇯🇲",
    "code": "JM"
},
{
    "label": "Japan",
    "value": "+81",
    "emoji": "🇯🇵",
    "code": "JP"
},
{
    "label": "Jersey",
    "value": "+44",
    "emoji": "🇯🇪",
    "code": "JE"
},
{
    "label": "Jordan",
    "value": "+962",
    "emoji": "🇯🇴",
    "code": "JO"
},
{
    "label": "Kazakhstan",
    "value": "+77",
    "emoji": "🇰🇿",
    "code": "KZ"
},
{
    "label": "Kenya",
    "value": "+254",
    "emoji": "🇰🇪",
    "code": "KE"
},
{
    "label": "Kiribati",
    "value": "+686",
    "emoji": "🇰🇮",
    "code": "KI"
},
{
    "label": "Korea, Democratic People's Republic of Korea",
    "value": "+850",
    "emoji": "🇰🇵",
    "code": "KP"
},
{
    "label": "Korea, Republic of South Korea",
    "value": "+82",
    "emoji": "🇰🇷",
    "code": "KR"
},
{
    "label": "Kuwait",
    "value": "+965",
    "emoji": "🇰🇼",
    "code": "KW"
},
{
    "label": "Kyrgyzstan",
    "value": "+996",
    "emoji": "🇰🇬",
    "code": "KG"
},
{
    "label": "Laos",
    "value": "+856",
    "emoji": "🇱🇦",
    "code": "LA"
},
{
    "label": "Latvia",
    "value": "+371",
    "emoji": "🇱🇻",
    "code": "LV"
},
{
    "label": "Lebanon",
    "value": "+961",
    "emoji": "🇱🇧",
    "code": "LB"
},
{
    "label": "Lesotho",
    "value": "+266",
    "emoji": "🇱🇸",
    "code": "LS"
},
{
    "label": "Liberia",
    "value": "+231",
    "emoji": "🇱🇷",
    "code": "LR"
},
{
    "label": "Libyan Arab Jamahiriya",
    "value": "+218",
    "emoji": "🇱🇾",
    "code": "LY"
},
{
    "label": "Liechtenstein",
    "value": "+423",
    "emoji": "🇱🇮",
    "code": "LI"
},
{
    "label": "Lithuania",
    "value": "+370",
    "emoji": "🇱🇹",
    "code": "LT"
},
{
    "label": "Luxembourg",
    "value": "+352",
    "emoji": "🇱🇺",
    "code": "LU"
},
{
    "label": "Macao",
    "value": "+853",
    "emoji": "🇲🇴",
    "code": "MO"
},
{
    "label": "Macedonia",
    "value": "+389",
    "emoji": "🇲🇰",
    "code": "MK"
},
{
    "label": "Madagascar",
    "value": "+261",
    "emoji": "🇲🇬",
    "code": "MG"
},
{
    "label": "Malawi",
    "value": "+265",
    "emoji": "🇲🇼",
    "code": "MW"
},
{
    "label": "Malaysia",
    "value": "+60",
    "emoji": "🇲🇾",
    "code": "MY"
},
{
    "label": "Maldives",
    "value": "+960",
    "emoji": "🇲🇻",
    "code": "MV"
},
{
    "label": "Mali",
    "value": "+223",
    "emoji": "🇲🇱",
    "code": "ML"
},
{
    "label": "Malta",
    "value": "+356",
    "emoji": "🇲🇹",
    "code": "MT"
},
{
    "label": "Marshall Islands",
    "value": "+692",
    "emoji": "🇲🇭",
    "code": "MH"
},
{
    "label": "Martinique",
    "value": "+596",
    "emoji": "🇲🇶",
    "code": "MQ"
},
{
    "label": "Mauritania",
    "value": "+222",
    "emoji": "🇲🇷",
    "code": "MR"
},
{
    "label": "Mauritius",
    "value": "+230",
    "emoji": "🇲🇺",
    "code": "MU"
},
{
    "label": "Mayotte",
    "value": "+262",
    "emoji": "🇾🇹",
    "code": "YT"
},
{
    "label": "Mexico",
    "value": "+52",
    "emoji": "🇲🇽",
    "code": "MX"
},
{
    "label": "Micronesia, Federated States of Micronesia",
    "value": "+691",
    "emoji": "🇫🇲",
    "code": "FM"
},
{
    "label": "Moldova",
    "value": "+373",
    "emoji": "🇲🇩",
    "code": "MD"
},
{
    "label": "Monaco",
    "value": "+377",
    "emoji": "🇲🇨",
    "code": "MC"
},
{
    "label": "Mongolia",
    "value": "+976",
    "emoji": "🇲🇳",
    "code": "MN"
},
{
    "label": "Montenegro",
    "value": "+382",
    "emoji": "🇲🇪",
    "code": "ME"
},
{
    "label": "Montserrat",
    "value": "+1664",
    "emoji": "🇲🇸",
    "code": "MS"
},
{
    "label": "Morocco",
    "value": "+212",
    "emoji": "🇲🇦",
    "code": "MA"
},
{
    "label": "Mozambique",
    "value": "+258",
    "emoji": "🇲🇿",
    "code": "MZ"
},
{
    "label": "Myanmar",
    "value": "+95",
    "emoji": "🇲🇲",
    "code": "MM"
},
{
    "label": "Namibia",
    "emoji": "🇳🇦",
    "value": "+264",
    "code": "NA"
},
{
    "label": "Nauru",
    "value": "+674",
    "emoji": "🇳🇷",
    "code": "NR"
},
{
    "label": "Nepal",
    "value": "+977",
    "emoji": "🇳🇵",
    "code": "NP"
},
{
    "label": "Netherlands",
    "value": "+31",
    "emoji": "🇳🇱",
    "code": "NL"
},
{
    "label": "Netherlands Antilles",
    "value": "+599",
    "emoji": "🇧🇶",
    "code": "AN"
},
{
    "label": "New Caledonia",
    "value": "+687",
    "emoji": "🇳🇨",
    "code": "NC"
},
{
    "label": "New Zealand",
    "value": "+64",
    "emoji": "🇳🇿",
    "code": "NZ"
},
{
    "label": "Nicaragua",
    "value": "+505",
    "emoji": "🇳🇮",
    "code": "NI"
},
{
    "label": "Niger",
    "value": "+227",
    "emoji": "🇳🇪",
    "code": "NE"
},
{
    "label": "Nigeria",
    "value": "+234",
    "emoji": "🇳🇬",
    "code": "NG"
},
{
    "label": "Niue",
    "value": "+683",
    "emoji": "🇳🇺",
    "code": "NU"
},
{
    "label": "Norfolk Island",
    "value": "+672",
    "emoji": "🇳🇫",
    "code": "NF"
},
{
    "label": "Northern Mariana Islands",
    "value": "+1670",
    "emoji": "🇲🇵",
    "code": "MP"
},
{
    "label": "Norway",
    "value": "+47",
    "emoji": "🇳🇴",
    "code": "NO"
},
{
    "label": "Oman",
    "value": "+968",
    "emoji": "🇴🇲",
    "code": "OM"
},
{
    "label": "Pakistan",
    "value": "+92",
    "emoji": "🇵🇰",
    "code": "PK"
},
{
    "label": "Palau",
    "value": "+680",
    "emoji": "🇵🇼",
    "code": "PW"
},
{
    "label": "Palestinian Territory, Occupied",
    "value": "+970",
    "emoji": "🇵🇸",
    "code": "PS"
},
{
    "label": "Panama",
    "value": "+507",
    "emoji": "🇵🇦",
    "code": "PA"
},
{
    "label": "Papua New Guinea",
    "value": "+675",
    "emoji": "🇵🇬",
    "code": "PG"
},
{
    "label": "Paraguay",
    "value": "+595",
    "emoji": "🇵🇾",
    "code": "PY"
},
{
    "label": "Peru",
    "value": "+51",
    "emoji": "🇵🇪",
    "code": "PE"
},
{
    "label": "Philippines",
    "value": "+63",
    "emoji": "🇵🇭",
    "code": "PH"
},
{
    "label": "Pitcairn",
    "value": "+872",
    "emoji": "🇵🇳",
    "code": "PN"
},
{
    "label": "Poland",
    "value": "+48",
    "emoji": "🇵🇱",
    "code": "PL"
},
{
    "label": "Portugal",
    "value": "+351",
    "emoji": "🇵🇹",
    "code": "PT"
},
{
    "label": "Puerto Rico",
    "value": "+1939",
    "emoji": "🇵🇷",
    "code": "PR"
},
{
    "label": "Qatar",
    "value": "+974",
    "emoji": "🇶🇦",
    "code": "QA"
},
{
    "label": "Romania",
    "value": "+40",
    "emoji": "🇷🇴",
    "code": "RO"
},
{
    "label": "Russia",
    "value": "+7",
    "emoji": "🇷🇺",
    "code": "RU"
},
{
    "label": "Rwanda",
    "value": "+250",
    "emoji": "🇷🇼",
    "code": "RW"
},
{
    "label": "Reunion",
    "value": "+262",
    "emoji": "🇷🇪",
    "code": "RE"
},
{
    "label": "Saint Barthelemy",
    "value": "+590",
    "emoji": "🇧🇱",
    "code": "BL"
},
{
    "label": "Saint Helena, Ascension and Tristan Da Cunha",
    "value": "+290",
    "emoji": "🇸🇭",
    "code": "SH"
},
{
    "label": "Saint Kitts and Nevis",
    "value": "+1869",
    "emoji": "🇰🇳",
    "code": "KN"
},
{
    "label": "Saint Lucia",
    "value": "+1758",
    "emoji": "🇱🇨",
    "code": "LC"
},
{
    "label": "Saint Martin",
    "value": "+590",
    "emoji": "🇲🇫",
    "code": "MF"
},
{
    "label": "Saint Pierre and Miquelon",
    "value": "+508",
    "emoji": "🇵🇲",
    "code": "PM"
},
{
    "label": "Saint Vincent and the Grenadines",
    "value": "+1784",
    "emoji": "🇻🇨",
    "code": "VC"
},
{
    "label": "Samoa",
    "value": "+685",
    "emoji": "🇼🇸",
    "code": "WS"
},
{
    "label": "San Marino",
    "value": "+378",
    "emoji": "🇸🇲",
    "code": "SM"
},
{
    "label": "Sao Tome and Principe",
    "value": "+239",
    "emoji": "🇸🇹",
    "code": "ST"
},
{
    "label": "Saudi Arabia",
    "value": "+966",
    "emoji": "🇸🇦",
    "code": "SA"
},
{
    "label": "Senegal",
    "value": "+221",
    "emoji": "🇸🇳",
    "code": "SN"
},
{
    "label": "Serbia",
    "value": "+381",
    "emoji": "🇷🇸",
    "code": "RS"
},
{
    "label": "Seychelles",
    "value": "+248",
    "emoji": "🇸🇨",
    "code": "SC"
},
{
    "label": "Sierra Leone",
    "value": "+232",
    "emoji": "🇸🇱",
    "code": "SL"
},
{
    "label": "Singapore",
    "value": "+65",
    "emoji": "🇸🇬",
    "code": "SG"
},
{
    "label": "Slovakia",
    "value": "+421",
    "emoji": "🇸🇰",
    "code": "SK"
},
{
    "label": "Slovenia",
    "value": "+386",
    "emoji": "🇸🇮",
    "code": "SI"
},
{
    "label": "Solomon Islands",
    "value": "+677",
    "emoji": "🇸🇧",
    "code": "SB"
},
{
    "label": "Somalia",
    "value": "+252",
    "emoji": "🇸🇴",
    "code": "SO"
},
{
    "label": "South Africa",
    "value": "+27",
    "emoji": "🇿🇦",
    "code": "ZA"
},
{
    "label": "South Sudan",
    "value": "+211",
    "emoji": "🇸🇸",
    "code": "SS"
},
{
    "label": "South Georgia and the South Sandwich Islands",
    "value": "+500",
    "emoji": "🇬🇸",
    "code": "GS"
},
{
    "label": "Spain",
    "value": "+34",
    "emoji": "🇪🇸",
    "code": "ES"
},
{
    "label": "Sri Lanka",
    "value": "+94",
    "emoji": "🇱🇰",
    "code": "LK"
},
{
    "label": "Sudan",
    "value": "+249",
    "emoji": "🇸🇩",
    "code": "SD"
},
{
    "label": "Surilabel",
    "value": "+597",
    "emoji": "🇸🇷",
    "code": "SR"
},
{
    "label": "Svalbard and Jan Mayen",
    "value": "+47",
    "emoji": "🇸🇯",
    "code": "SJ"
},
{
    "label": "Swaziland",
    "value": "+268",
    "emoji": "🇸🇿",
    "code": "SZ"
},
{
    "label": "Sweden",
    "value": "+46",
    "emoji": "🇸🇪",
    "code": "SE"
},
{
    "label": "Switzerland",
    "value": "+41",
    "emoji": "🇨🇭",
    "code": "CH"
},
{
    "label": "Syrian Arab Republic",
    "value": "+963",
    "emoji": "🇸🇾",
    "code": "SY"
},
{
    "label": "Taiwan",
    "value": "+886",
    "emoji": "🇹🇼",
    "code": "TW"
},
{
    "label": "Tajikistan",
    "value": "+992",
    "emoji": "🇹🇯",
    "code": "TJ"
},
{
    "label": "Tanzania, United Republic of Tanzania",
    "value": "+255",
    "emoji": "🇹🇿",
    "code": "TZ"
},
{
    "label": "Thailand",
    "value": "+66",
    "emoji": "🇹🇭",
    "code": "TH"
},
{
    "label": "Timor-Leste",
    "value": "+670",
    "emoji": "🇹🇱",
    "code": "TL"
},
{
    "label": "Togo",
    "value": "+228",
    "emoji": "🇹🇬",
    "code": "TG"
},
{
    "label": "Tokelau",
    "value": "+690",
    "emoji": "🇹🇰",
    "code": "TK"
},
{
    "label": "Tonga",
    "value": "+676",
    "emoji": "🇹🇴",
    "code": "TO"
},
{
    "label": "Trinidad and Tobago",
    "value": "+1868",
    "emoji": "🇹🇹",
    "code": "TT"
},
{
    "label": "Tunisia",
    "value": "+216",
    "emoji": "🇹🇳",
    "code": "TN"
},
{
    "label": "Turkey",
    "value": "+90",
    "emoji": "🇹🇷",
    "code": "TR"
},
{
    "label": "Turkmenistan",
    "value": "+993",
    "emoji": "🇹🇲",
    "code": "TM"
},
{
    "label": "Turks and Caicos Islands",
    "value": "+1649",
    "emoji": "🇹🇨",
    "code": "TC"
},
{
    "label": "Tuvalu",
    "value": "+688",
    "emoji": "🇹🇻",
    "code": "TV"
},
{
    "label": "Uganda",
    "value": "+256",
    "emoji": "🇺🇬",
    "code": "UG"
},
{
    "label": "Ukraine",
    "value": "+380",
    "emoji": "🇺🇦",
    "code": "UA"
},
{
    "label": "United Arab Emirates",
    "value": "+971",
    "emoji": "🇦🇪",
    "code": "AE"
},
{
    "label": "United Kingdom",
    "value": "+44",
    "emoji": "🇬🇧",
    "code": "GB"
},
{
    "label": "United States",
    "value": "+1",
    "emoji": "🇺🇸",
    "code": "US"
},
{
    "label": "Uruguay",
    "value": "+598",
    "emoji": "🇺🇾",
    "code": "UY"
},
{
    "label": "Uzbekistan",
    "value": "+998",
    "emoji": "🇺🇿",
    "code": "UZ"
},
{
    "label": "Vanuatu",
    "value": "+678",
    "emoji": "🇻🇺",
    "code": "VU"
},
{
    "label": "Venezuela, Bolivarian Republic of Venezuela",
    "value": "+58",
    "emoji": "🇻🇪",
    "code": "VE"
},
{
    "label": "Vietnam",
    "value": "+84",
    "emoji": "🇻🇳",
    "code": "VN"
},
{
    "label": "Virgin Islands, British",
    "value": "+1284",
    "emoji": "🇻🇬",
    "code": "VG"
},
{
    "label": "Virgin Islands, U.S.",
    "value": "+1340",
    "emoji": "🇻🇮",
    "code": "VI"
},
{
    "label": "Wallis and Futuna",
    "value": "+681",
    "emoji": "🇼🇫",
    "code": "WF"
},
{
    "label": "Yemen",
    "value": "+967",
    "emoji": "🇾🇪",
    "code": "YE"
},
{
    "label": "Zambia",
    "value": "+260",
    "emoji": "🇿🇲",
    "code": "ZM"
},
{
    "label": "Zimbabwe",
    "value": "+263",
    "emoji": "🇿🇼",
    "code": "ZW"
}
]

module.exports = dialCodeList;